import { Component, OnInit, Inject, Optional } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { Rider } from '../../../../../../commons/models/riders';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import * as RidersActions from '../../../../../../store/actions/riders.actions';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../../../store/reducers';
import { AlertService } from '../../../../../../commons/services/alert.service';

@Component({
  selector: 'app-new-rider',
  templateUrl: './new-rider.component.html',
  styleUrls: ['./new-rider.component.scss']
})
export class NewRiderComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();
  ridersForm: UntypedFormGroup;
  riders: Rider;

  isEditing: boolean = false;
  hasPassword: boolean = false;

  constructor(
    private store$: Store<AppState>,
    private alertService: AlertService,
    private fb: UntypedFormBuilder,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    if (this.data && this.data.rider) {
      this.riders = this.data.rider;
      this.isEditing = true;
      this.hasPassword = !!this.riders.password;
    }
    this._createForm();
    this.ngOnChanges();

  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private _createForm() {
    let riderGroup = {
      name: ["", Validators.required],
      surname: ["", Validators.required],
      phone: ["", Validators.required],
      active: [true],
      defaultTenantId: [""],
      email: ["", Validators.email],
      password: [""],
      //drives_own_car: [""]
    };

    this.ridersForm = this.fb.group(riderGroup);
  }


  private ngOnChanges() {
    if (this.ridersForm) {
      this.ridersForm.reset();

      this._initFormValues(this.riders);
    }
}

  private _initFormValues(rider?: Rider) {
    if(rider){
      this.ridersForm.patchValue({
      name: rider.name,
      surname: rider.surname,
      phone: rider.phone,
      active: rider.active,
      defaultTenantId: rider.defaultTenantId,
      email: rider.email,
      //password: rider.password
      password: this.hasPassword ? '******' : ''

    });
    } else {
      this.ridersForm.markAllAsTouched();
    }
  }

  private _prepareSaveRider(): Rider {
    let formValue = this.ridersForm.value;
    if (formValue.password === '******') {
      formValue.password = '';
    }
    return Rider.fromFormGroup(this.ridersForm, this.riders);
  }

  save() {
    let unsavedEntity = this._prepareSaveRider();
    this.store$.dispatch(RidersActions.saveRider({ riders: unsavedEntity }));
  }

  close() {
    if (this.ridersForm.dirty) {
      // Se ci sono modifiche, mostra il dialog di conferma
      this.store$.dispatch(RidersActions.requestCloseRidersDialog());
    } else {
      // Se il form è pristine (nessuna modifica), chiudi
      this.store$.dispatch(RidersActions.closeRidersDialog());
    }
  }

  deleteRider() {
    if (this.riders) {
        this.store$.dispatch(RidersActions.deleteRider({ rider: this.riders.toDTO() }));
    }
  }

  revert() {
  this.ngOnChanges();
  }

  onPasswordFocus() {
    if (this.ridersForm.get('password')?.value === '******') {
      this.ridersForm.patchValue({ password: '' });
    }
  }

}
